// PDFPagination.js
import { Pagination } from "antd";
import { PDF_PREVIEW_ROWS } from "../../../reportExport";

// JFCRX-7643. The page size defaults to the one constant the preview slices
// by, so the pager and the preview footer cannot count differently.
const PDFPagination = ({
  totalItems,
  currentPage,
  onPageChange,
  pageSize = PDF_PREVIEW_ROWS,
}) => (
  <div style={{ marginTop: 20, display: "flex", justifyContent: "center" }}>
    <Pagination
      current={currentPage + 1}
      defaultCurrent={1}
      total={totalItems}
      pageSize={pageSize}
      onChange={(page) => onPageChange(page - 1)}
      showSizeChanger={false}
    />
  </div>
);

export default PDFPagination;
